import Banner from "./Components/Banner";
import HomeCard from "./Components/HomeCard";
import { useTranslation } from "react-i18next";


import cosechando from "../../assets/iconos/cosechando.svg"
import numeros from "../../assets/iconos/numeros.svg"
import puente from "../../assets/iconos/puente.svg"
import opsaa from "../../assets/iconos/opsaa.svg"

const Intro = () => {
  const { t } = useTranslation("translation", { keyPrefix: "intro" });

  //TODO: Implementar traduccion, modificar banner y verificar logo opsaa
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Banner />
        </div>
      </div>
      <div className="row text-center mt-4">
        <div className="col-xl-3 col-lg-6">
          <HomeCard
            type={{
              type: "info",
              icon: numeros,
              text: t('numeros'),
            }}
            navigate="/iica-numeros"
          />
        </div>
        <div className="col-xl-3 col-lg-6">
          <HomeCard
            type={{
              type: "info",
              icon: opsaa,
              text: t("observatorio"),
            }}
            navigate="/opsaa"
          />
        </div>
        <div className="col-xl-3 col-lg-6">
          <HomeCard
            type={{
              type: "info",
              icon: cosechando,
              text: t('resultados'),
            }}
            navigate="/iniciativas/palabras-clave"
          />
        </div>
        <div className="col-xl-3 col-lg-6">
          <HomeCard
            type={{
              type: "info",
              icon: puente,
              text: t('alianzas'),
            }}
            navigate="/iniciativas/contrapartes"
          />
        </div>
      </div>
    </>
  );
};

export default Intro;
